require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-las-nuevas-politicas-ambientales-y-sociales-protegeran.json") })
        }
      }, "path---es-mx-update-las-nuevas-politicas-ambientales-y-sociales-protegeran");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-las-nuevas-politicas-ambientales-y-sociales-protegeran!./.cache/json/es-mx-update-las-nuevas-politicas-ambientales-y-sociales-protegeran.json
// module id = 932
// module chunks = 231608221292675